import React from 'react';
import PropTypes from 'prop-types';
import { ListSection } from '../../../shared/ListSection';
import { BusinessNavigationListItem } from './BusinessNavigationListItem';
import BusinessesImage from './images/businesses.svg';
import HowItWorksImage from './images/how-it-works.svg';
import OurPromiseImage from './images/our-promise.svg';
import SupportImage from './images/support.svg';
import SavingsImage from './images/savings.svg';
import { STYLES } from '../../../../style';

const data = [
  {
    title: 'Business benefits',
    image: BusinessesImage,
    url: '/businesses',
    color: STYLES.PAGE_BUSINESSES_BANNER_COLOR,
  },
  {
    title: 'How it works',
    image: HowItWorksImage,
    url: '/businesses/how-to',
    color: STYLES.PAGE_BUSINESSES_HOW_TO_BANNER_COLOR,
  },
  {
    title: 'Our promise',
    image: OurPromiseImage,
    url: '/businesses/security',
    color: STYLES.PAGE_BUSINESSES_SECURITY_BANNER_COLOR,
  },
  {
    title: 'Support',
    image: SupportImage,
    url: '/businesses/support',
    color: STYLES.PAGE_BUSINESSES_SUPPORT_BANNER_COLOR,
  },
  {
    title: 'Cost savings',
    image: SavingsImage,
    url: '/businesses/savings',
    color: STYLES.PAGE_BUSINESSES_SAVINGS_BANNER_COLOR,
  },
];

const BusinessNavigation = ({ pathname }) => {
  const newData = data.map(
    d => ({ ...d, active: pathname.replace(/\/$/, '') === d.url }),
  );
  return (
    <ListSection
      component={BusinessNavigationListItem}
      data={newData}
    />
  );
};

BusinessNavigation.propTypes = {
  pathname: PropTypes.string.isRequired,
};

export { BusinessNavigation };